/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Step/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaStep from 'DesignSystem/TysiaStep/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Step({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/Connection/Content/EditPreferences/Content/Main/Content/Content/Steps/Step"
  
}) {
let stepsCurrentIndexValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'current_index',
})
let stepItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let aggregateData = fromAggregate.equals(stepsCurrentIndexValueData, stepItemIndexValueData)
let stepItemIndexValueData1 = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let constantData = 1
let aggregateData1 = fromAggregate.add(stepItemIndexValueData1, constantData)
let stepNameValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'name',
})
let stepItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'isLast',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Step.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaStep
  viewPath={`${viewPath}/TysiaStep`}
 data="steps.current_index"
 data="step_item.index"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
 data="step_item.index"
 data={1}
 aggregate="/Data/aggregate.js add"
 step={aggregateData1}
 data="step.name"
 text={stepNameValueData}
 weight="medium"
 size="normal"
/>
<fromFlow.When is={!stepItemIsLastValueData}>
<div
  data-testid="Step.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-1-bokV': dtColorsNeutral300,'--ml-2-bokV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-bokV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}